document.addEventListener('DOMContentLoaded', function () {
  // === FIX sept 2026: tap para agrandar videos hover (mobile no tiene :hover) ===
  var items = document.querySelectorAll('.pdp-hover-video-item');
  if (items.length) {
    var overlay = document.createElement('div');
    overlay.className = 'oskin-video-lightbox';
    overlay.innerHTML = '<button type="button" class="oskin-video-lightbox-close" aria-label="Cerrar video">&times;</button><div class="oskin-video-lightbox-inner"></div>';
    document.body.appendChild(overlay);
    var inner = overlay.querySelector('.oskin-video-lightbox-inner');
    var closeBtn = overlay.querySelector('.oskin-video-lightbox-close');

    function closeLightbox() {
      overlay.classList.remove('is-open');
      inner.innerHTML = '';
      document.body.classList.remove('oskin-lightbox-open');
    }
    closeBtn.addEventListener('click', closeLightbox);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeLightbox();
    });

    items.forEach(function (item) {
      item.addEventListener('click', function (e) {
        var vid = item.querySelector('video');
        if (!vid) return;
        e.preventDefault();
        var clone = vid.cloneNode(true);
        clone.muted = false;
        clone.controls = true;
        clone.autoplay = true;
        clone.loop = true;
        clone.setAttribute('playsinline', '');
        inner.innerHTML = '';
        inner.appendChild(clone);
        overlay.classList.add('is-open');
        document.body.classList.add('oskin-lightbox-open');
        var playPromise = clone.play();
        if (playPromise && playPromise.catch) { playPromise.catch(function () {}); }
      });
    });
  }

  // === FIX sept 2026: video de "Conocé el producto" arranca solo al hacer scroll ===
  var introVid = document.querySelector('.pdp-video-media-col video');
  if (introVid && 'IntersectionObserver' in window) {
    introVid.muted = true;
    introVid.setAttribute('muted', '');
    introVid.setAttribute('playsinline', '');
    var introObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var p = introVid.play();
          if (p && p.catch) { p.catch(function () {}); }
        } else {
          introVid.pause();
        }
      });
    }, { threshold: 0.5 });
    introObserver.observe(introVid);
  }
});
